import React, { useEffect, useState } from 'react'
import { getUA, getUserInfo } from '@penguin/utils'
import queryString from 'query-string'
import styles from './wechat.module.css'
import { getSchemaUrl, getWxConfig } from '@/api'
import { useLongPress } from '@/hooks'
import { STATS_MAP } from '@/utils'
const isWxMini = window?.__wxjs_environment === 'miniprogram'
const index = () => {
  const parsed = queryString.parse(window.location.search) as { channel?: string }
  const ua = getUA()
  const isWx = isWxMini || ua === 'wechat' || ua === 'wechatMini'
  const [schemaUrl, setSchema] = useState('')
  const [wechatUrl, setWechatUrl] = useState('')
  // ua 为wechat的时候才监听长按事件
  const longPressHandler =
    ua === 'wechat'
      ? useLongPress(
          () => {
            //  console.log('长按事件')
          },
          () => {
            //  console.log('点击事件')
          },
          () => {
            window.aplus_queue.push({
              action: 'aplus.record',
              arguments: [STATS_MAP.wechat.longpress, 'CLK'],
            })
          },
        )
      : {}
  const goToMini = async () => {
    const userInfo: any = ua === 'app' ? getUserInfo() : {}
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [STATS_MAP.wechat.click, 'CLK'],
    })
    if (schemaUrl) {
      window.location.href = schemaUrl
      return
    }
    const data = await getSchemaUrl({
      path: '/pages/adWebview/adWebview',
      query: `linkUrl=${encodeURIComponent(window.location.href)}&needLogin=1&phone=${
        userInfo?.phone || ''
      }`,
      envVersion: process.env.REACT_APP_NODE_ENV !== 'production' ? 'develop' : 'release',
    })
    setSchema(data)
    window.location.href = data
  }
  useEffect(() => {
    getWxConfig().then((res) => {
      const { qrcodeUrl, integralCodeUrl } = res
      if (parsed.channel === 'credit') {
        setWechatUrl(integralCodeUrl)
      } else if (parsed.channel === 'threeSheep') {
        setWechatUrl('//static.qiekj.com/static/web/image/threeSheepWx_1723462590747.png')
      } else {
        setWechatUrl(qrcodeUrl)
      }
    })

    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.wechat.exposure,
        'CLK',
        {
          page: location.pathname,
          type: getUA(),
        },
      ],
    })
  }, [])
  return (
    <div
      className={` relative min-h-screen bg-wechat ${
        parsed.channel === 'threeSheep' && styles['three-sheep-bg']
      }`}
      {...longPressHandler}
    >
      <img
        className='w-full'
        src={
          parsed.channel === 'credit'
            ? '//static.qiekj.com/static/web/image/wechat-bg_1690874295722.png'
            : parsed.channel === 'threeSheep'
            ? '//static.qiekj.com/static/web/image/banner_1723080484415.png'
            : '//static.qiekj.com/static/web/image/marketing-wechat_1709192910335.png'
        }
        alt=''
      />
      <div className=' pr-7 pl-7 rem:mt-[-54px] pb-5'>
        <div className=' bg-white p-2 rem:rounded-[20px] flex flex-col items-center pt-5 relative'>
          <img
            className=' rem:w-[254px]'
            src='//static.qiekj.com/static/web/image/wechat-title_1689817212522.png'
            alt=''
          />
          <div
            className={`${styles.qrcode} rem:w-[214px] rem:h-[214px] mt-3 flex justify-center items-center`}
          >
            <img className=' rem:w-[184px] rem:h-[184px]' src={wechatUrl} alt='' />
          </div>
          {!isWx ? (
            <img
              className={styles.finger}
              onClick={goToMini}
              src='//static.qiekj.com/static/web/image/app-open-btn_1689817212522.png'
              alt=''
            />
          ) : (
            <img
              className=' rem:w-[244px] mt-3'
              src='//static.qiekj.com/static/web/image/wechat-btn_1689818694311.png'
              alt=''
            />
          )}
          {isWx && (
            <img
              className={` rem:w-[68px] rem:h-[63px] absolute right-0 bottom-9 ${styles.finger}`}
              src='//static.qiekj.com/static/web/image/hand_1689818694311.png'
              alt=''
            />
          )}
        </div>
        <div className=' text-tip text-sm mt-4 leading-6 text-center'>更多奖励活动等你来解锁</div>
      </div>
    </div>
  )
}

export default index
